<template lang="pug">
    section.main-tab
        el-row.no-margin(:gutter="20")
            el-col(:sm="12")
                el-form-item(:label="$t('Name')" prop="name")
                    el-input(v-model="name" maxlength="255" show-word-limit)
            el-col(:sm="12")
                el-form-item(:label="$t('Key')" prop="key")
                    el-input(v-model="key" maxlength="255" show-word-limit)

        el-form-item(:label="$t('Description')" prop="description")
            el-input(
                v-model="description"
                type="textarea"
                :autosize="{ minRows: 4, maxRows: 40 }"
            )

        .properties.table-content
            el-form-item(:label="$t('Properties')" prop="properties")
                el-select.is-full-width(
                    v-model="properties"
                    value-key="id"
                    multiple
                    :class="{ loading: options.property.loading }"
                )
                    el-option(
                        v-for="item in options.property.items"
                        :key="item.id"
                        :label="item.name"
                        :value="item"
                    )
            table.table(v-if="properties.length")
                thead
                    tr
                        th.grip
                        th.key {{ $t('Key') }}
                        th.name {{ $t('Name') }}
                        th.actions
                draggable(
                    v-model="properties"
                    tag="tbody"
                    group="properties"
                    handle=".grip"
                )
                    tr.clickable(v-for="property in properties" :key="property.id")
                        td.grip.text-gray
                            i.fas.el-icon-fa-grip-vertical
                        td.key {{ property.key }}
                        td.name {{ property.name }}
                        td.actions
                            //- el-button.action.danger.icon-only(
                            //-     size="mini"
                            //-     type="text"
                            //-     @click="removeSection"
                            //- )
                            //-     i.el-icon-fa-trash-alt.fas
</template>

<i18n>
{
    "de": {
        "Key": "Eindeutige Kennung",
        "Name": "Name",
        "Properties": "Attribute",
        "Add property": "Attribut hinzufügen"
    }
}
</i18n>

<script>
import _ from 'lodash';
import uniqid from 'uniqid';
import draggable from 'vuedraggable';
import { fromUnixTime, format } from 'date-fns';
import pinia from '@/pinia';
import { useSetupStore, useShopPropSetStore } from '@/stores';

import store from '@/store'
import AuthApi from '@/store/api/system/auth';

export default {
    name: 'MainTab',
    components: {
        draggable,
    },
    computed: {
        id() {
            return _.get(this.form, 'id');
        },
        name: {
            get() {
                return _.get(this.form, 'name', '');
            },
            set(value) {
                this.setName(value);
            }
        },
        key: {
            get() {
                return _.get(this.form, 'key', '');
            },
            set(value) {
                this.setKey(value);
            }
        },
        description: {
            get() {
                return _.get(this.form, 'description', '');
            },
            set(value) {
                this.setDescription(value);
            }
        },
        properties: {
            get() {
                return _.get(this.form, 'properties') || [];
            },
            set(value) {
                let properties = _.cloneDeep(value);

                // properties.forEach((property, i) => {
                //     const position = i + 1;
                //     property.position = position;
                // });

                this.setProperties(properties);
            }
        },
        setupStore() {
            return useSetupStore();
        },
        activeCms() {
            return this.setupStore.activeCms;
        },
        propSetStore() {
            return useShopPropSetStore(pinia);
        },
        form() {
            return this.propSetStore.form;
        },
        options() {
            return this.propSetStore.options;
        },
    },
    methods: {
        // addProperty() {
        // },
        setName(value) {
            this.propSetStore.setFormName(value);
        },
        setKey(value) {
            this.propSetStore.setFormKey(value);
        },
        setDescription(value) {
            this.propSetStore.setFormDescription(value);
        },
        setProperties(value) {
            this.propSetStore.setFormProperties(value);
        }
    },
};
</script>

<style lang="sass" scoped>
.text-gray
    font-weight: 400 !important
    color: $color-grey-text

table
    margin-top: 4rem
    border-collapse: collapse
    tbody
        tr:nth-child(even)
            background: darken($--background-color-base, 1%)
        tr:nth-child(odd)
            background: lighten($--background-color-base, 1%)
    .grip, .key
        width: 1px
        white-space: nowrap
    .grip
        cursor: grab
    .actions
        width: 1px
        white-space: nowrap
</style>
